import { List } from 'immutable'

export default function ListModel(valueMapper = x => x, name) {
  const ListModelExtender = {
    set(index, value) {
      return extendList(List.prototype.set.call(this, index, valueMapper(value, index)))
    },
    insert(index, value) {
      return extendList(List.prototype.insert.call(this, index, valueMapper(value, index)))
    },
    push(...values) {
      return extendList(List.prototype.push.apply(this, values.map(valueMapper)))
    },
    unshift(...values) {
      return extendList(List.prototype.unshift.apply(this, values.map(valueMapper)))
    },
    concat(...valuesOrIterables) {
      return extendList(
        List.prototype.concat.apply(
          this,
          valuesOrIterables.map(valueOrIterable => valueOrIterable.map(valueMapper))
        )
      )
    },
    clone() {
      return extendList(
        List.prototype.map.call(this, (v, index) =>
          valueMapper(null != v && 'object' == typeof v && 'function' == typeof v.clone ? v.clone() : v, index)
        )
      )
    },
    isListModel: true
  }
  ;[
    'delete',
    'pop',
    'shift',
    'update',
    'merge',
    'mergeWith',
    'mergeDeep',
    'mergeDeepWith',
    'setSize',
    'setIn',
    'deleteIn',
    'updateIn',
    'mergeIn',
    'mergeDeepIn',
    'withMutations',
    'asMutable',
    'asImmutable',
    'map',
    'filter',
    'filterNot',
    'reverse',
    'sort',
    'sortBy',
    'slice',
    'rest',
    'butLast',
    'skip',
    'skipLast',
    'skipWhile',
    'skipUntil',
    'take',
    'takeLast',
    'takeWhile',
    'takeUntil',
    'flatten',
    'flatMap',
    'interpose',
    'interleave',
    'splice',
    'zip',
    'zipWith '
  ].forEach(function (fnName) {
    if ('function' == typeof List.prototype[fnName]) {
      ListModelExtender[fnName] = function (...args) {
        const returned = List.prototype[fnName].apply(this, args)
        return List.isList(returned) ? extendList(returned) : returned
      }
    }
  })

  const emptyListModel = extendList(Object.assign(List([0]), List()))
  ListModelExtender.clear = function () {
    return emptyListModel
  }

  function extendList(list) {
    if (list === List()) return emptyListModel
    if ('string' === typeof name && name.length) {
      list[`is${name}`] = true
      list.toString = function () {
        return List.prototype.__toString.call(this, `${name} [`, ']')
      }
    }
    return Object.assign(list, ListModelExtender)
  }

  function ListModel(value) {
    return extendList(List(value).map(valueMapper))
  }
  ListModel.of = function (...values) {
    return extendList(List.of(...values.map(valueMapper)))
  }
  if ('string' == typeof name && name.length) {
    ListModel[`is${name}`] = function (maybeListModel) {
      return List.isList(maybeListModel) && maybeListModel[`is${name}`]
    }
  }

  return ListModel
}

ListModel.isListModel = function (maybeListModel) {
  return List.isList(maybeListModel) && maybeListModel.isListModel
}
